import { ChildrenAnimalMotifProps } from '@ahc-digital/component-library';
import { C46ChildrensAnimalMotifProps } from './C46ChildrensAnimalMotif';
import { Image as JSSImage, Text as JSSText } from '@sitecore-jss/sitecore-jss-nextjs';

export function CreatechildrenAnimalMotif(
  props?: C46ChildrensAnimalMotifProps
): ChildrenAnimalMotifProps {
  const animals = [
    {
      image: <JSSImage field={props?.fields?.FirstAnimalimage} loading="lazy" />,
      quote: <JSSText field={props?.fields?.FirstAnimalQuote} />,
    },
    {
      image: <JSSImage field={props?.fields?.SecondAnimalImage} loading="lazy" />,
      quote: <JSSText field={props?.fields?.SecondAnimalQuote} />,
    },
    {
      image: <JSSImage field={props?.fields?.ThirdAnimalImage} loading="lazy" />,
      quote: <JSSText field={props?.fields?.ThirdAnimalQuote} />,
    },
    {
      image: <JSSImage field={props?.fields?.FourthAnimalImage} loading="lazy" />,
      quote: <JSSText field={props?.fields?.FourthAnimalQuote} />,
    },
    {
      image: <JSSImage field={props?.fields?.FifthAnimalImage} loading="lazy" />,
      quote: <JSSText field={props?.fields?.FifthAnimalQuote} />,
    },
  ];
  const staticMobileImage = <JSSImage field={props?.fields?.StaticMobileImage} loading="lazy" />;
  return {
    staticMobileImage,
    animals,
  };
}
